import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';

export const offTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.OFF,
  hover: {},
  click: {},
  idle: {},
  dragStart: {},
  particles: {
    enabled: false,
    count: 0,
    characters: [],
    spread: 0,
    duration: 0,
    size: 0,
  },
  keyframes: [],
  metadata: {
    label: 'Off',
    icon: IconName.X,
    previewEmoji: '🚫',
    description: 'No playful effects',
    mascotEmoji: '',
  },
};
